import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, IconButton, Paper, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import '../../../Styles/react-tagsinput.css'
import { ContextNotification, severitys } from "../../../App";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import FlightCompensationApi from "../../../api/FlightCompensationApi";
import helper from "../../../helper";
import ConfirmationDialog from "../../../Components/ConfirmationDialog";
import { MdDelete, MdEditSquare } from "react-icons/md";
import { DataGrid } from "@mui/x-data-grid";
import CustomTitle from "../../../Components/CustomTitle";
const EditAirLinePenaltyRate = ({ row, Refresh }) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const { setOpen } = useContext(ContextNotification);
  const customization = useSelector((state) => state.customization);
  const [isloading, setIsLoading] = useState(false);
  const [rows,setRows]=useState([]);

  const schema = yup.object().shape({
    penaltyPercent: yup.string().required(' درصد جریمه را مشخص نمائید'),
    fromHour: yup.string().required(' حد پایین تاخیر را وارد نمائید'),
    toHour: yup.string().required(' حد بالای تاخیر را وارد نمائید'),
  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
    defaultValues: {
      penaltyPercent: row?.penaltyPercent ? parseInt(row.penaltyPercent) : null,
      fromHour: row?.fromHour ? parseInt(row?.fromHour) : null,
      toHour: row?.toHour ? parseInt(row?.toHour) : null,
    },
    resolver: yupResolver(schema),
  });
  const Columns = [
    { field: "fromHour", headerName: "میزان تاخیر از (ساعت)", width: '150' },
    { field: "toHour", headerName: "میزان تاخیر تا(ساعت)", width: '150' },
    { field: "penaltyPercent", headerName: "درصد جریمه", width: '100' }

  ];
  Columns.push({
    field: "ویرایش", renderCell: (cellValues) => {
      return (
        <IconButton
          disabled={isloading}
          sx={{ color: '#c70c05c2' }}
          onClick={() => {
            handleOpenEdit(cellValues.row)
          }}><MdEditSquare />
        </IconButton>
      )
    }
  });
  Columns.push({
    field: "حذف", renderCell: (cellValues) => {
      return (
        <IconButton
          disabled={isloading}
          sx={{ color: '#c70c05c2' }}
          onClick={() => {
            handleOpenDelete(cellValues.row)
          }}><MdDelete />
        </IconButton>
      )
    }
  });

  useEffect(() => {
setSelectedDelaypenalty(null);
    setValue("fromHour", "");
    setValue("toHour", "");
    setValue("penaltyPercent", "");
     setRows(row.airLinePenaltyRateInfo)  
  }, [row]);


  ///delete/////////////////////////////////////
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteDate, setDeleteData] = useState(null);
  const handleOpenDelete = (data) => {
    setOpenDelete(true);
    setDeleteData(data);
  };
  const handleDeleteRow = () => {
    setIsLoading(true);
    FlightCompensationApi.deleteAirLinePenaltyRate(deleteDate.id).then(res => {
      if (res.status === 200) {
        if (res.data.success) {
          setOpen({ IsEnable: true, Message: 'سطر مورد نظر با موفقیت حذف شد', severity: severitys.success });
          resetForm();
          Refresh();
        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

        }

      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
      }

    }).catch(err => {

      if (err.response && err.response.data) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
      }
      else if (err.response && err.response.data && err.response.data.errors) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
      else if (err.message) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
      }

    }).finally(() => { setIsLoading(false) });
  }
  ////////Edit/////////////////////////
  const [selectedDelaypenalty, setSelectedDelaypenalty] = useState(null);
  const handleOpenEdit = (data) => {
    if (selectedDelaypenalty?.id === data.id) {
      setSelectedDelaypenalty(null);
      setValue("fromHour", "");
      setValue("toHour", "");
      setValue("penaltyPercent", "");
    }
    else {
      setSelectedDelaypenalty(data);
      setValue("fromHour", String(data.fromHour));
      setValue("toHour", String(data.toHour));
      setValue("penaltyPercent", String(data.penaltyPercent));

    }

  }

  ////////////////////////

  const onSubmit = () => {
    var fromHour = null;
    if (watch("fromHour"))
      fromHour = watch("fromHour")
    var toHour = null;
    if (watch("toHour"))
      toHour = watch("toHour")
    var penaltyPercent = null;
    if (watch("penaltyPercent"))
      penaltyPercent = watch("penaltyPercent")
    const data = {
      'fromHour': fromHour,
      'toHour': toHour,
      'penaltyPercent': parseInt(penaltyPercent),
    }
    setSubmitLoading(true);
    if (selectedDelaypenalty === null)//add mode
    {
      FlightCompensationApi.AddAirLinePenaltyRate(row?.id, data).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            setOpen({ IsEnable: true, Message: 'درصد جریمه با موفقیت افزوده شد', severity: severitys.success });
            resetForm();
            Refresh();
          }
          else {
            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

          }

        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
        }

      }).catch(err => {

        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }).finally(() => { setSubmitLoading(false) });
    }
    else {
      FlightCompensationApi.UpdateAirLinePenaltyRate(selectedDelaypenalty.id, data).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            setOpen({ IsEnable: true, Message: 'ویرایش جریمه با موفقیت انجام شد', severity: severitys.success });
            resetForm();
            Refresh();
          }
          else {
            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

          }

        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
        }

      }).catch(err => {

        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }).finally(() => { setSubmitLoading(false) });
    }

  }


  const resetForm = () => {
    setSelectedDelaypenalty(null);
    setValue("fromHour", "");
    setValue("toHour", "");
    setValue("penaltyPercent", "");
  }
  const handleChangeFromHour=(value)=>{
   if ((value!==null) && (parseInt(value) > 0)) {
     setValue("fromHour",value);
   }
  else
  {
    setValue("fromHour",null);
  }
}
  const handleChangeToHour=(value)=>{
   if ((value!==null) && (parseInt(value) > 0)) {
     setValue("toHour",value);
   }
  else
  {
    setValue("toHour",null);
  }
}
  const handleChangePenaltyPercent=(value)=>{
   if ((value!==null) && (parseInt(value) > 0)) {
     setValue("penaltyPercent",value);
   }
  else
  {
    setValue("penaltyPercent",null);
  }
}
  return (
    <Box sx={{ m: 2 }}>
      <ThemeProvider theme={customtheme(customization)}>
        <RtlProvider>
          <CustomTitle title={'درصد خسارت بر اساس میزان تاخیر'} icon={null} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={1}>
              <Grid item md={3.5} xs={5.5}>
                <TextField
                  type='number'
                  label="تاخیر از(ساعت)"
                  {...register("fromHour")}
                   onChange={(event)=>{handleChangeFromHour(event.target.value);}}
                />
              </Grid>
              <Grid item md={3.5} xs={5.5} >
                <TextField
                  type='number'
                  label="تاخیر تا (ساعت)"
                  {...register("toHour")}
                   onChange={(event)=>{handleChangeToHour(event.target.value);}}
                />

              </Grid>
              <Grid item md={3} xs={5.5}>
                <TextField
                    type='number'
                  label="درصد جریمه"
                  {...register("penaltyPercent")}
                  onChange={(event)=>{handleChangePenaltyPercent(event.target.value);}}
                />
              </Grid>
              <Grid item md={2} xs={3.5}>
                <Button type="submit" disabled={submitLoading} sx={{ mt: 1 }} variant="contained" color="primary" fullwidth >
                  <BeatLoading loading={submitLoading} color={"#e65100"} /> {(selectedDelaypenalty !== null) ? 'ویرایش' : 'ثبت'}</Button>
              </Grid>
            </Grid>
            <Paper sx={{ mt: 2, width: "100%", height: "500px" }}>
              <DataGrid
                rows={rows}
                columns={Columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 50,
                    },
                  },
                }}
                pageSizeOptions={[25, 50, 100]}
                checkboxSelection={false}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnSelector
                loading={isloading}
                sx={{
                  backgroundColor: '#F1F1E8', // Set your desired background color    
                  '& .MuiDataGrid-columnHeaders > div[role="row"]': {
                    color: '#F1F1E8!important',
                    backgroundColor: '#50a193ff!important',
                  },
                }}
              />
            </Paper >
            <ConfirmationDialog
              open={openDelete}
              handleClose={() => setOpenDelete(false)}
              deleteFunction={handleDeleteRow}
            />
          </form>
        </RtlProvider>
      </ThemeProvider>
    </Box >
  )
}
export default EditAirLinePenaltyRate